import axios, { InternalAxiosRequestConfig, AxiosError } from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: { "Content-Type": "application/json" },
});

// Interceptor pour ajouter le token
api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem("token");

  if (
    token &&
    config.url &&
    !config.url.includes("/login") &&
    !config.url.includes("/register")
  ) {
    config.headers.set("Authorization", `Bearer ${token}`);
  }

  return config;
});

// Interceptor pour gérer les erreurs de réponse
api.interceptors.response.use(
  (response: any) => response, // on laisse passer la réponse si tout va bien
  (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      // 🚨 Token invalide ou expiré
      localStorage.removeItem("token"); // optionnel : nettoyer le token
      window.location.href = "/login";  // redirection vers la page de login
    }

    // 402 Payment Required (#102) — abonnement expiré → redirige vers /dashboard/subscription
    // (sauf si on y est déjà, pour éviter une boucle)
    if (error.response && error.response.status === 402) {
      const detail = (error.response.data as { detail?: string } | undefined)?.detail || '';
      if (detail.startsWith('subscription_expired')) {
        const lang = window.location.pathname.split('/')[1] || 'fr';
        const target = `/${lang}/dashboard/subscription`;
        if (!window.location.pathname.startsWith(target)) {
          window.location.href = target;
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api;
